import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { HowWorkGarant } from '../../components/HowWorkGarant';
import { useApplicationContext } from '../../../common/utils/applicationContext';
import { showSellerHowItWork } from '../../components/tracking';

export const HowWorkGarantContainer: React.FC = () => {
  const { custom } = useApplicationContext();

  return (
    <ActionAfterViewObserver callback={() => showSellerHowItWork(custom)}>
      <HowWorkGarant context={custom} />
    </ActionAfterViewObserver>
  );
};
